import { useAuthStore } from '../stores/authStore';
import { useNewTradeRequestStore } from '../stores/newTradeRequestStore';
import { useRegistrationStore } from '../stores/registrationStore';
import { useVerificationStore } from '../stores/verificationStore';

/**
 * Utility function to perform logout across all stores
 * This can be used in service contexts where hooks are not available
 */
export const performLogout = () => {
  try {
    // Call each store's logout method
    useAuthStore.getState().logout();
    useRegistrationStore.getState().logout();
    useVerificationStore.getState().logout();
    useNewTradeRequestStore.getState().logout();
  } catch (error) {
    console.error('Error during logout:', error);
    // Continue with logout even if some stores fail
  }
};
